import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Unknown error" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI Crash:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary"
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#0a0a0a",
            color: "#e4e4e7",
            fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            padding: "24px",
          }}
        >
          <div style={{ maxWidth: 480, textAlign: "left" }}>
            <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>
              Something went wrong
            </h2>
            <p style={{ fontSize: 14, color: "#a1a1aa", marginBottom: 16 }}>
              The interface hit an unexpected error. Please refresh, or contact
              support if this keeps happening.
            </p>
            {this.state.message ? (
              <pre
                style={{
                  fontSize: 12,
                  color: "#71717a",
                  background: "#18181b",
                  border: "1px solid #27272a",
                  borderRadius: 8,
                  padding: 12,
                  marginBottom: 16,
                  whiteSpace: "pre-wrap",
                }}
              >
                {this.state.message}
              </pre>
            ) : null}
            <button
              data-testid="error-boundary-reload-btn"
              onClick={this.handleReload}
              style={{
                background: "#facc15",
                color: "#000",
                border: "none",
                borderRadius: 8,
                padding: "10px 16px",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Refresh
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
